import { render, staticRenderFns } from "./TreeViewcopy.vue?vue&type=template&id=501f39b8&scoped=true&"
import script from "./TreeViewcopy.vue?vue&type=script&lang=js&"
export * from "./TreeViewcopy.vue?vue&type=script&lang=js&"
import style0 from "./TreeViewcopy.vue?vue&type=style&index=0&id=501f39b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501f39b8",
  null
  
)

export default component.exports